import { combineReducers } from "redux";
import { messageDetailReducer } from "./messageDetailReducer";
import { productDetailReducer } from "./productDetailReducer";
import { cartDetailReducer } from "./cartDetailReducer";
import { sessionReducer } from "./sessionReducer";
import { chatReducer } from "./chatReducer";
import { adminReducer } from "./adminReducer";
export const rootReducer = combineReducers({
  messageDetail: messageDetailReducer,
  productDetail: productDetailReducer,
  cartDetail: cartDetailReducer,
  session: sessionReducer,
  chatDetail: chatReducer,
  adminDetail: adminReducer,
});
